import { useTranslation } from "react-i18next";
import { Loader } from "@/shared/components/ui";
interface PageLoaderProps {
    message?: string;
}

export function PageLoader({ message }: PageLoaderProps) {
    const { t } = useTranslation("shared");
    const displayMessage = message ?? t("loader.loading");
    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 dark:from-background dark:to-card">
            <div className="flex flex-col items-center gap-4">
                <Loader size="lg" />
                <p className="text-slate-600 dark:text-muted-foreground font-medium">{displayMessage}</p>
            </div>
        </div>
    );
}

interface SectionLoaderProps {
    message?: string;
    size?: "sm" | "md" | "lg";
}

export function SectionLoader({ message, size = "md" }: SectionLoaderProps) {
    return (
        <div className="flex flex-col items-center justify-center py-12">
            <Loader size={size} />
            {message && (
                <p className="mt-4 text-sm text-muted-foreground">{message}</p>
            )}
        </div>
    );
}

interface CenteredLoaderProps {
    message?: string;
}

/**
 * Full-height, vertically-centered loader.
 *
 * Used for both the route-level Suspense fallback (while the page's lazy JS
 * chunk downloads) AND the page's own data-loading state, so the two phases
 * render an identical spinner in the same position — a single, continuous
 * loading experience instead of a "top spinner then middle spinner" jump.
 */
export function CenteredLoader({ message }: CenteredLoaderProps) {
    return (
        <div className="h-full min-h-[60vh] flex items-center justify-center">
            <div className="flex flex-col items-center gap-4 animate-fade-in">
                <Loader size="lg" />
                {message && (
                    <p className="text-sm font-medium text-muted-foreground">{message}</p>
                )}
            </div>
        </div>
    );
}
